import { createSlice } from "@reduxjs/toolkit"

export const reConstructionMaterialPeriodPriceReducer = createSlice({
	name: 'reConstructionMaterialPeriodPriceReducer',
	initialState: {
		isLoading: false,
		error: null,
		paged: {},
	},
	reducers: {
		setLoading: (state) => {
			state.isLoading = true
		},
		setError: (state, action) => {
			state.isLoading = false
			state.error = action.payload
		},
		getPagedSuccess: (state, action) => {
			state.isLoading = false
			state.paged = action.payload
		},
		clear: (state) => {
			state.isLoading = false
			state.paged = {}
			state.error = null
		},
	}
})

export default reConstructionMaterialPeriodPriceReducer.reducer;